import api from "./api";

// ======================
// Portfolio
// ======================
export const movePortfolioUp = (id) =>
  api.patch(`/portfolio/${id}/up`);

export const movePortfolioDown = (id) =>
  api.patch(`/portfolio/${id}/down`);

export const getPortfolio = () => api.get("/portfolio");

export const createPortfolio = (data) =>
  api.post("/portfolio", data);

export const updatePortfolio = (id, data) =>
  api.put(`/portfolio/${id}`, data);

export const deletePortfolio = (id) =>
  api.delete(`/portfolio/${id}`);

// ======================
// Publications
// ======================

export const movePublicationUp = (id) =>
  api.patch(`/publications/${id}/up`);

export const movePublicationDown = (id) =>
  api.patch(`/publications/${id}/down`);

export const getPublications = () =>
  api.get("/publications");

export const createPublication = (data) =>
  api.post("/publications", data);

export const updatePublication = (id, data) =>
  api.put(`/publications/${id}`, data);

export const deletePublication = (id) =>
  api.delete(`/publications/${id}`);

// ======================
// Community
// ======================

export const moveCommunityUp = (id) =>
  api.patch(`/community/${id}/up`);

export const moveCommunityDown = (id) =>
  api.patch(`/community/${id}/down`);

export const getCommunity = () =>
  api.get("/community");

export const createCommunity = (data) =>
  api.post("/community", data);

export const updateCommunity = (id, data) =>
  api.put(`/community/${id}`, data);

export const deleteCommunity = (id) =>
  api.delete(`/community/${id}`);